// node_modules/@shopify/theme-currency/currency.js
var moneyFormat = "${{amount}}";
function formatMoney(cents, format) {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  let value = "";
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  const formatString = format || moneyFormat;
  function formatWithDelimiters(number, precision = 2, thousands = ",", decimal = ".") {
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    const parts = number.split(".");
    const dollarsAmount = parts[0].replace(
      /(\d)(?=(\d\d\d)+(?!\d))/g,
      `$1${thousands}`
    );
    const centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }
  return formatString.replace(placeholderRegex, value);
}

// src/utils/pricing.js
var pricing = (price) => {
  if (price != null) {
    return `${formatMoney(price, window.product.money_format).replace(
      ",00",
      ""
    )}`;
  }
};

// src/extenders/product-quantity-selector.js
if (!customElements.get("quantity-selector")) {
  customElements.define(
    "quantity-selector",
    class QuantitySelector extends HTMLElement {
      constructor() {
        super();
        this.quantitySelectElement = this.querySelector('select[name="quantity"]');
      }
      connectedCallback() {
        this.quantitySelectElement.addEventListener("change", this.onChangeHandler.bind(this));
      }
      onChangeHandler(event) {
        var _a;
        const newQuantity = event.target.value;
        const basePrice = (_a = document.querySelector("product-info product-form .price-holder")) == null ? void 0 : _a.getAttribute("data-base-price");
        const newPrice = basePrice * newQuantity;
        document.querySelector("product-info product-form .price-holder").querySelector(".price").innerText = pricing(newPrice);
      }
    }
  );
}
